import { CmsApiSupportContactFormBlockData } from 'modules/cms/api/types/blocks/CmsApiSupportContactFormBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpSupportContactFormBlock } from './CmsAmpSupportContactFormBlock';
import { CmsSupportContactFormBlock } from './CmsSupportContactFormBlock';

export const CmsSupportContactFormBlockMapping: CmsBlockMapping<CmsApiSupportContactFormBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsSupportContactFormBlock,
    AmpComponent: CmsAmpSupportContactFormBlock,
  };
